import {PayAsYouGoBilling, PayAsYouGoBillingContracts} from '.';

function mapInvoice(c: PayAsYouGoBillingContracts.Invoice): PayAsYouGoBilling.Invoice {
  return {
    date: c.issuance_at,
    unify: {
      usage: c.unify_total_cost_usd,
    },
    lvs: {
      usage: c.transcriber_total_cost_usd,
      hours: c.transcriber_hours,
      billedHours: c.transcriber_billable_hours,
    },
    edge: c.tier_usage_total_cost_usd,
    total: c.total_period_amount_usd,
  };
}

function mapHistory(c: PayAsYouGoBillingContracts.History): PayAsYouGoBilling.History {
  return {
    upcoming: c.upcoming_info ? mapInvoice(c.upcoming_info) : undefined,
    history: c.history,
  };
}

export const payasyougoBillingMapper = {mapHistory};
